import React, { FC } from 'react'
import {
  IconLogoVisa,
  IconLogoMastercard,
  IconLogoApplePay,
  IconLogoPaypal,
  IconLogoIdeal,
  IconLogoKlarna,
  IconLogoAmericanExpress,
  IconLogoGooglePay,
} from '@moonpig/launchpad-assets'
import { useStoreId } from '@moonpig/web-core-stores'
import { PaymentMethodsPerRegion } from '@moonpig/web-core-brand/config'
import { FooterNavSection } from './FooterNavSection'
import { useLocaleText } from '../locale'

const logoMap = {
  Visa: { Component: IconLogoVisa, width: '40px', height: '40px' },
  Mastercard: { Component: IconLogoMastercard, width: '40px', height: '33px' },
  'Google Pay': { Component: IconLogoGooglePay, width: '55px', height: '40px' },
  'Apple Pay': { Component: IconLogoApplePay, width: '40px', height: '33px' },
  PayPal: { Component: IconLogoPaypal, width: '55px', height: '40px' },
  Ideal: { Component: IconLogoIdeal, width: '40px', height: '33px' },
  Klarna: { Component: IconLogoKlarna, width: '40px', height: '33px' },
  'American Express': {
    Component: IconLogoAmericanExpress,
    width: '40px',
    height: '33px',
  },
}

export type PaymentProviders = keyof typeof logoMap

type PaymentMethodProps = {
  providers?: PaymentMethodsPerRegion
}

export const PaymentMethods: FC<
  React.PropsWithChildren<PaymentMethodProps>
> = ({ providers: providersByCountryCode }) => {
  const t = useLocaleText()

  const storeId = useStoreId()
  const providers = providersByCountryCode
    ? providersByCountryCode[storeId]
    : (['Visa', 'Mastercard', 'Apple Pay', 'PayPal'] as const)

  return (
    <div data-testid="lp-nav-footernav-paymentmethods">
      <FooterNavSection
        title={t(`footer.nav.payment_methods`)}
        colGap={{ xs: 3, md: 4 }}
      >
        {providers?.map(provider => {
          const { width, height, Component } = logoMap[provider]
          return (
            <li key={provider}>
              <Component
                role="img"
                aria-label={provider}
                width={width}
                height={height}
              />
            </li>
          )
        })}
      </FooterNavSection>
    </div>
  )
}
